import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Flex, Box, Heading, Text, Button } from "rebass/styled-components"
import Modal from "styled-react-modal"
import { InputNoForm } from "../TextInput"
interface ISearchPatientInput {
  isMinified: boolean
}
const SearchPatientInput = ({ isMinified }: ISearchPatientInput) => {
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [searchTerms, setSearchTerms] = useState('')
  const navigate = useNavigate()
  function toggleModal() {
    setSearchTerms('')
    setIsModalOpened(false)
  }

  const onSearch = () => {
    const search = searchTerms.toString()

    let value: string | number

    try {
      value = parseInt(search)
    } catch (error) {
      value = search
    }

    if (!value) {
      value = search
    }

    setSearchTerms('')

    if (isNaN(value as any)) {
      setIsModalOpened(false)
      navigate(`/patients`, {
        state:{
          search:search
        }
      })
    } else {
      setIsModalOpened(false)
      navigate(`/patient/${search.trim()}`)
    }

  }

  return <>
    <Flex flexDirection={'row'} style={{ background: 'white', borderRadius: '12px', padding: '0 6px 0 12px', marginBottom: '24px', height: '50px', cursor: isMinified ? 'pointer' : '' }} alignItems='center'
      onClick={() => {
        if (isMinified) {
          setIsModalOpened(true)
        }
      }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: isMinified ? '0 auto' : '' }}>
        <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
      </svg>
      {!isMinified && (
        <InputNoForm
          style={{ backgroundColor: 'white', border: '0px', flex: 1, paddingTop: '12px', paddingBottom: '12px' }}
          containerStyle={{ width: '100%' }}
          placeholder='last name or id'
          onChange={(e: any) => setSearchTerms(e.target.value)}
          value={searchTerms}
          onReturn={onSearch} />
      )}

    </Flex>
    {!!isModalOpened && (
      <Modal
        isOpen={isModalOpened}
        onBackgroundClick={toggleModal}
        onEscapeKeydown={toggleModal}>
        <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <Heading mb={3}>Search Patient</Heading>
          <Text mb={4} >Enter patient's last name or Athena ID</Text>
          <InputNoForm
            autoFocus
            style={{ backgroundColor: 'white', flex: 1, minWidth: '330px', textAlign: 'center' }}
            placeholder='last name or patient id'
            onChange={(e: any) => setSearchTerms(e.target.value)}
            value={searchTerms}
            onReturn={onSearch}
          />
          <Button variant={'primary'} mt={4} disabled={!searchTerms}>Search</Button>
          <Box onClick={toggleModal} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
            X
          </Box>
        </Box>
      </Modal>)}
  </>
}

export default SearchPatientInput